// Messages Trends Chart Configuration
export const getMessagesTrendChartOptions = (chartData) => ({
  chart: {
    height: 300,
    type: 'line',
    stacked: true,
    toolbar: {
      show: false
    },
    zoom: {
      enabled: false
    }
  },
  stroke: {
    curve: 'smooth',
    width: [0, 0, 0, 0, 0, 3], // 0 width for columns, 3 for trend line
    dashArray: [0, 0, 0, 0, 0, 0] // Solid line for trend
  },
  plotOptions: {
    bar: {
      columnWidth: '60%'
    }
  },
  colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#FF6B6B'],
  fill: {
    type: 'solid',
    opacity: 0.8
  },
  dataLabels: {
    enabled: false
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'right'
  },
  xaxis: {
    categories: chartData.categories,
    title: {
      text: 'Time',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    }
  },
  yaxis: {
    title: {
      text: 'Number of Messages',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    },
    labels: {
      formatter: function (val) {
        return val.toFixed(0);
      }
    }
  },
  grid: {
    borderColor: '#e7e7e7',
    strokeDashArray: 3
  },
  tooltip: {
    shared: true,
    intersect: false,
    custom: function({ series, seriesIndex, dataPointIndex, w }) {
      // Get all series data for this data point
      const seriesData = series.map((s, i) => ({
        name: w.globals.seriesNames[i],
        value: s[dataPointIndex],
        color: w.globals.colors[i]
      }));
      
      // Reverse to show highest at bottom
      seriesData.reverse();
      
      const category = w.globals.labels[dataPointIndex] || w.config.xaxis.categories[dataPointIndex] || '';
      
      let html = '<div class="apexcharts-tooltip-custom" style="padding: 8px; background: white; border: 1px solid #e3e3e3; border-radius: 4px;">';
      html += `<div style="margin-bottom: 6px; font-weight: 600; color: #333;">${category}</div>`;
      
      seriesData.forEach(s => {
        html += `<div style="display: flex; align-items: center; margin-bottom: 3px;">`;
        html += `<span style="width: 10px; height: 10px; background-color: ${s.color}; border-radius: 2px; margin-right: 6px;"></span>`;
        html += `<span style="color: #666; font-size: 12px;">${s.name}: <strong>${s.value} messages</strong></span>`;
        html += `</div>`;
      });
      
      html += '</div>';
      return html;
    }
  },
  markers: {
    size: 4,
    hover: {
      size: 6
    }
  }
});

// FOTA Bar Chart Configuration
export const getFotaBarChartConfig = (fotametricsdata) => ({
  series: [{
    name: 'Vehicle Count',
    data: fotametricsdata.map(function (metrics) { return metrics.VehicleCount; })
  }],
  options: {
    chart: {
      type: 'bar',
      height: 250,
      toolbar: {
        show: false
      }
    },
    plotOptions: {
      bar: {
        distributed: true,
        horizontal: true,
        borderRadius: 2,
        dataLabels: {
          position: 'right',
        }
      }
    },
    colors: ["#808080", "#4A90E2", "#50C878", "#FF6B6B", "#FFD93D", "#A855F7"],
    legend: {
      show: false
    },
    dataLabels: {
      enabled: true,
      textAnchor: 'start',
      style: {
        colors: ["#000000"],
        fontSize: '11px'
      },
      offsetX: 5,
      formatter: function (val) {
        return val;
      }
    },
    xaxis: {
      categories: fotametricsdata.map(function (metrics) { return metrics.FOTAVersion; }),
      labels: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
    },
    grid: {      
      xaxis: {
        lines: {
          show: false,
        },
      },
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val + " vehicles";
        }
      }
    }
  }
});

// VNC Trend Chart Configuration
export const getVncTrendChartOptions = (vncTrendData) => ({
  chart: {
    height: 250,
    type: 'line',
    toolbar: {
      show: false
    },
    zoom: {
      enabled: false
    }
  },
  stroke: {
    curve: 'straight',
    width: 3
  },
  colors: ['#FF6B6B'], // Red color for VNC trend
  dataLabels: {
    enabled: false
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'right'
  },
  xaxis: {
    categories: vncTrendData.categories,
    title: {
      text: 'Time',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    }
  },
  yaxis: {
    title: {
      text: 'VNC Count',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    },
    labels: {
      formatter: function (val) {
        return val.toFixed(0);
      }
    }
  },
  grid: {
    borderColor: '#e7e7e7',
    strokeDashArray: 3
  },
  tooltip: {
    shared: true,
    intersect: false,
    y: {
      formatter: function (val) {
        return val + " vehicles not communicating";
      }
    }
  },
  markers: {
    size: 4,
    hover: {
      size: 6
    }
  }
});

// Telematics Error Stacked Column Chart Configuration
export const getTelematicsErrorChartOptions = (categories) => ({
  chart: {
    type: 'bar',
    height: 350,
    stacked: true,
    toolbar: {
      show: false
    }
  },
  plotOptions: {
    bar: {
      horizontal: false,
      columnWidth: '60%',
      borderRadius: 2,
    }
  },
  colors: ['#FF4444', '#FF8C00', '#FFA500', '#FFD700', '#FF6B6B', '#DC143C'],
  dataLabels: {
    enabled: false
  },
  legend: {
    show: true,
    position: 'top',
    horizontalAlign: 'center',
    fontSize: '12px',
    markers: {
      width: 12,
      height: 12,
      radius: 2
    }
  },
  xaxis: {
    categories: categories,
    title: {
      text: 'Time',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    },
    labels: {
      style: {
        fontSize: '10px'
      }
    }
  },
  yaxis: {
    title: {
      text: 'Error Count',
      style: {
        fontSize: '12px',
        color: '#666'
      }
    },
    labels: {
      formatter: function (val) {
        return Math.floor(val);
      }
    }
  },
  grid: {
    borderColor: '#e7e7e7',
    strokeDashArray: 3
  },
  tooltip: {
    shared: true,
    intersect: false,
    custom: function({ series, seriesIndex, dataPointIndex, w }) {
      // Get all series data for this data point
      const seriesData = series.map((s, i) => ({
        name: w.globals.seriesNames[i],
        value: s[dataPointIndex],
        color: w.globals.colors[i]
      }));
      
      // Reverse to show highest at bottom
      seriesData.reverse();
      
      const category = w.globals.labels[dataPointIndex] || w.config.xaxis.categories[dataPointIndex] || '';
      
      let html = '<div class="apexcharts-tooltip-custom" style="padding: 8px; background: white; border: 1px solid #e3e3e3; border-radius: 4px;">';
      html += `<div style="margin-bottom: 6px; font-weight: 600; color: #333;">${category}</div>`;
      
      seriesData.forEach(s => {
        html += `<div style="display: flex; align-items: center; margin-bottom: 3px;">`;
        html += `<span style="width: 10px; height: 10px; background-color: ${s.color}; border-radius: 2px; margin-right: 6px;"></span>`;
        html += `<span style="color: #666; font-size: 12px;">${s.name}: <strong>${s.value} errors</strong></span>`;
        html += `</div>`;
      });
      
      html += '</div>';
      return html;
    }
  }
});
